<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/ui/AppIcon.vue'
import BaseButton from '@/components/ui/BaseButton.vue'

defineProps<{ message?: string | null; title?: string }>()
const emit = defineEmits<{ retry: [] }>()

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col items-center justify-center px-6 py-12 text-center" role="alert">
    <div
      class="mb-4 flex size-12 items-center justify-center rounded-full bg-red-50 text-red-500 dark:bg-red-950"
      aria-hidden="true"
    >
      <AppIcon name="triangle-alert" size="lg" />
    </div>

    <h3 class="text-sm font-semibold text-gray-900 dark:text-white">
      {{ title || t('states.errorTitle') }}
    </h3>
    <p class="mt-1 max-w-md text-sm text-gray-500 dark:text-neutral-400">
      {{ message || t('states.errorHint') }}
    </p>

    <BaseButton class="mt-5" variant="secondary" size="sm" icon="refresh" @click="emit('retry')">
      {{ t('common.retry') }}
    </BaseButton>
  </div>
</template>
